import { useState } from 'react'
import { EditFilenameModalState } from '../hooks/useEditFilenameModal/types'
import { Button, Space } from 'antd'
import { useGlobalState } from 'context/GlobalStateContext'
import { EditFilenameModalProps } from '../types'
import { errorHandler } from 'hooks/errorHandler'

function Footer<T extends EditFilenameModalState>({
  context,
  edit,
  postEdit,
}: Pick<EditFilenameModalProps<T>, 'edit' | 'context' | 'postEdit'>) {
  const { toggle, setTemplateItems, state, templateItems, valid } = context
  const {
    state: { projectGlobalId },
  } = useGlobalState()
  const [loading, setLoading] = useState(false)
  return (
    <Space>
      <Button disabled={loading} loading={loading} onClick={() => toggle(null)}>
        Cancel
      </Button>
      <Button
        loading={loading}
        disabled={loading}
        onClick={() =>
          setTemplateItems(
            (state?.defaultTemplateItems ?? []).map((item) => {
              let value
              if (item.type === 'custom') value = item.text
              else value = item.templateItemId
              return { type: item.type, value }
            })
          )
        }
      >
        Reset to Default
      </Button>
      <Button
        loading={loading}
        disabled={loading}
        type="primary"
        onClick={async () => {
          if (!valid) return
          if (!state) return errorHandler('state is not defined')
          if (!projectGlobalId) return errorHandler('projectId is not defined')
          setLoading(true)
          await edit(state, projectGlobalId, templateItems)
          setLoading(false)
          toggle(null)
          postEdit?.()
        }}
      >
        Ok
      </Button>
    </Space>
  )
}

export default Footer
